import React from "react";
import { Nav, Sidenav, Dropdown, Icon } from "rsuite";
import "rsuite/dist/styles/rsuite-default.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCoffee,
  faUser,
  faList,
  faKey,
  faHouseUser,
  faCog,
  faRupeeSign,
  faAtom,
  faCopyright,
  faFileContract,
} from "@fortawesome/free-solid-svg-icons";
//import styles from "./SideMenu.css";
import { getUserRole } from "../utils/index";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useRouteMatch,
  withRouter,
  useParams,
} from "react-router-dom";

class SideMenu extends React.Component {
  state = {
    openMenu: this.props.openMenu ? [this.props.openMenu] : [""],
    activeKey: this.props.activeKey ? this.props.activeKey : "1-1",
  };

  render() {
    let url = this.props.match;
    return (
      <div className="leftSidebar">
        <Sidenav
          activeKey={this.state.activeKey}
          openKeys={this.state.openMenu}
          onOpenChange={(openKeys, event) => {
            console.log(openKeys[openKeys.length - 1]);
            this.setState({ openMenu: [openKeys[openKeys.length - 1]] });
          }}
        >
          <Sidenav.Body>
            <Nav>
              <Dropdown
                eventKey="1"
                //onClick={alert(1)}
                title="Dashboard"
              // icon={<FontAwesomeIcon icon={faUser} />}
              >

                <Dropdown.Item
                  eventKey="1-1"
                  componentClass={Link}
                  to="/leads"
                  onSelect={() => {
                    this.state.activeKey = "1-1";
                  }}
                >
                  Dashboard
                </Dropdown.Item>
              </Dropdown>
              <Dropdown
                eventKey="2"
                title="Task Manager"
              //onOpen={alert(1)}
              // icon={<FontAwesomeIcon icon={faList} />}
              >

                <Dropdown.Item
                  eventKey="2-1"
                  componentClass={Link}
                  to={`${url.path}/my-task`}
                  onSelect={() => {
                    this.state.activeKey = "2-1";
                  }}
                >
                  My Task
                </Dropdown.Item>

              </Dropdown>

              {getUserRole() === 'admin' && (

              <Dropdown
                eventKey="3"
                title="Master"
              >

                <Dropdown.Item
                  eventKey="3-1"
                  componentClass={Link}
                  to={`${url.path}/master/sub-stage`}
                  onSelect={() => {
                    this.state.activeKey = "3-1";
                  }}
                >
                  Sub Stage
                </Dropdown.Item>

                <Dropdown.Item
                  eventKey="3-2"
                  componentClass={Link}
                  to={`${url.path}/master/drop-reason`}
                  onSelect={() => {
                    this.state.activeKey = "3-2";
                  }}
                >
                  Drop Reason 
                </Dropdown.Item>

              </Dropdown>
              
              )}




            </Nav>
          </Sidenav.Body>
        </Sidenav>
      </div>
    );
  }
}

export default withRouter(SideMenu);
